import React from 'react';
import { TokenVerifier } from '../../components/astrologer/verification';
import { RegistrationProvider } from '../../context/RegistrationContext';

const VerifyPage = () => {
  return (
    <RegistrationProvider>
      <TokenVerifier />
    </RegistrationProvider>
  );
};

export default VerifyPage;
